import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const GlobalInquiryOfferReplyCover = ({ notification, sender }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl
          ? `قام ${sender?.name} بالرد على عرضك لرؤى عالمية`
          : `${sender?.name} has replied to your offer on a global vision`
      }
    />
  )
}

export default GlobalInquiryOfferReplyCover
